module.exports = __webpack_public_path__ + "img/证书6.d2cba511.jpg";